import http from "../http";
import { LoginResponse } from "../../interfaces/api/auth/login";
import api from "../../config/api";

const auth = {
  /**
   * Logs in a user with the given FormData.
   * @param {FormData} formData - The FormData containing login and password.
   * @param {string} deviceUDID - The device UDID to send in the header.
   * @returns {Promise<LoginResponse>} A Promise that resolves to the login response.
   */
  login: (formData: FormData, deviceUDID: string): Promise<LoginResponse> => {
    return http.post(api.login, formData, { "X-Device-UDID": deviceUDID });
  },
};

export default auth;
